import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';

import {GetExamsDates, GetExamsDatesParams, GetExamsDatesModel} from 'domain/usecases';

export class RemoteGetExamsDates implements GetExamsDates {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamsDatesModel>,
	) {}

	async get({signal, ...params}: GetExamsDatesParams): Promise<GetExamsDatesModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
